const css = require("../css/common.css");
export default { css };
